import { makeStyles, Theme } from '@material-ui/core';
import React, { FC } from 'react';
import { AspectRatio } from '../aspect-ratio';

export const DEFAULT_BACKDROP = '/images/live-bg-bw.jpg';

interface IProps {
  backdrop?: string;
  maxHeight?: string;
  displayBackdrop: boolean;
}

const useStyles = makeStyles<Theme, Omit<IProps, 'children'>>((theme) => ({
  videoContainer: ({backdrop, displayBackdrop}) => ({
    opacity: displayBackdrop ? .8 : 1,
    maxHeight: 'calc(100vh - 8rem)',
    borderBottom:
      displayBackdrop ? 0 : `2px solid ${(theme.palette.background as any).shadedown_10}`,
    backgroundImage: displayBackdrop ? `url(${backdrop})` : 'none',
    backgroundSize: displayBackdrop ? 'cover' : '',
    backgroundRepeat: displayBackdrop ? 'no-repeat' : '',
    backgroundPosition: displayBackdrop ? 'center center' : '',
  })
}));

export const VideoContainer: FC<IProps> = ({
  backdrop = DEFAULT_BACKDROP,
  maxHeight = '56.25%',
  displayBackdrop,
  children,
}) => {
  const classes = useStyles({
    backdrop,
    maxHeight,
    displayBackdrop
  });

  return (
    <AspectRatio
        maxHeight={maxHeight}
        styles={{
            aspectContainer: classes.videoContainer 
        }}
    >
        {children}
    </AspectRatio> 
  );
};
